import { useTranslation } from "react-i18next";
import { dienstenItems } from "@/mocks/dienstenItems";

const IMAGES = [
  "/img/94-foto.jpeg",
  "/img/93-foto.jpeg",
  "/img/98-foto.jpeg",
  "/img/101-foto.jpeg",
  "/img/88-foto.jpeg",
  "/img/51-macro-security-door-lock.jpg",
  "/img/60-professional-craftsman-repairing-velux.jpg",
  "/img/43-security-specialist-replacing-damaged.jpg",
  "/img/44-various-window-handles-white.jpg",
  "/img/42-professional-replacing-rubber-window.jpg",
];

export default function DienstenRows() {
  const { t } = useTranslation("diensten");
  const items = dienstenItems;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-12 md:mb-16">
          {t("dienstenRows.h2")}
        </h2>

        <div className="flex flex-col gap-16 md:gap-24">
          {items.map((item, i) => {
            const isImageLeft = i % 2 === 0;
            return (
              <div
                key={i}
                className={`flex flex-col ${
                  isImageLeft ? "lg:flex-row" : "lg:flex-row-reverse"
                } gap-8 lg:gap-12 items-center`}
              >
                <div className="w-full lg:w-1/2">
                  <div className="aspect-[3/2] w-full rounded-xl overflow-hidden bg-brand-border relative">
                    <img
                      src={IMAGES[i]}
                      alt={item.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                    {(item as any).badge && (
                      <span className="absolute top-3 right-3 font-geist-mono text-xs font-bold bg-red-600 text-white px-2.5 py-1 rounded">
                        {(item as any).badge}
                      </span>
                    )}
                  </div>
                </div>

                <div className="w-full lg:w-1/2 flex flex-col justify-center">
                  <h3 className="font-geist font-bold text-xl md:text-2xl lg:text-[28px] text-brand-text tracking-tight mb-4">
                    {item.title}
                  </h3>
                  <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed mb-5">
                    {item.desc}
                  </p>
                  <p className="font-geist-mono text-lg md:text-xl text-brand-yellow bg-brand-text inline-block px-4 py-1.5 rounded-lg mb-6 self-start">
                    {item.price}
                  </p>
                  <a
                    href={item.link}
                    className="font-geist font-bold text-sm text-brand-blue hover:text-brand-text transition-colors inline-flex items-center gap-1.5 whitespace-nowrap group"
                  >
                    {item.linkText}
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-sm group-hover:translate-x-1 transition-transform"></i>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}